export default "__VITE_ASSET__CkoMxbax__"